import { Stack } from '@mui/material';
import { FormTextField } from 'src/components/Forms/FormTextField/form-text-field';
import {
  BLOCK_SHORT_TEXTAREA_PROPS,
  BLOCK_TEXT_FIELD_PROPS,
} from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/field-props';
import { blockFieldName } from 'src/pages/Settings/memberships/components/landing-page-tab/types';

interface PlansBlockFieldsProps {
  index: number;
  readOnly: boolean;
}

export const PlansBlockFields = ({ index, readOnly }: PlansBlockFieldsProps) => (
  <Stack gap={2.5}>
    <FormTextField
      type="textfield"
      name={blockFieldName(index, 'plansKicker')}
      label="Kicker"
      disabled={readOnly}
      textFieldProps={BLOCK_TEXT_FIELD_PROPS}
    />

    <FormTextField
      type="textfield"
      name={blockFieldName(index, 'plansTitle')}
      label="Title"
      disabled={readOnly}
      textFieldProps={BLOCK_TEXT_FIELD_PROPS}
    />

    <FormTextField
      type="textfield"
      name={blockFieldName(index, 'plansSubtext')}
      label="Subtext"
      disabled={readOnly}
      textFieldProps={BLOCK_SHORT_TEXTAREA_PROPS}
    />
  </Stack>
);
